import React from "react";
import { Grid } from "@material-ui/core";
import ModuleVideo from "./ModuleVideo";

export const ModuleVideos = ({ classes, clips }) => (
  <Grid container>
    {clips.map((clip, i) => (
      <Grid item xs={12} key={i}>
        <ModuleVideo name={clip.name} videoUrl={clip.videoUrl} />
      </Grid>
    ))}
  </Grid>
);
